/**
 * Behandelingskosten herstellingen — forfait diagnostiek
 * when the customer does not repair and does not buy a new machine.
 * Source: Welda prijsbord (vanaf 05/01/2023).
 *
 * Amounts used for billing are excl. BTW.
 */
const BESTEK_FORFAIT_DIAGNOSTIEK = [
  { key: "bosch", label: "Bosch", priceExcl: 45.45, priceIncl: 55.0 },
  { key: "carat", label: "Carat", priceExcl: 66.12, priceIncl: 80.0 },
  {
    key: "compressoren_mono",
    label: "Compressoren mono",
    priceExcl: 45.45,
    priceIncl: 55.0,
  },
  {
    key: "compressoren_driefasig",
    label: "Compressoren driefasig",
    priceExcl: 95.04,
    priceIncl: 115.0,
  },
  { key: "fein", label: "Fein", priceExcl: 53.72, priceIncl: 65.0 },
  { key: "hikoki", label: "Hikoki", priceExcl: 45.45, priceIncl: 55.0 },
  {
    key: "kranzle_klein",
    label: "Kranzle klein",
    priceExcl: 74.38,
    priceIncl: 90.0,
  },
  {
    key: "kranzle_groot",
    label: "Kranzle groot",
    priceExcl: 95.04,
    priceIncl: 115.0,
  },
  {
    key: "kranzle_warmwater",
    label: "Kranzle warmwater",
    priceExcl: 181.82,
    priceIncl: 220.0,
  },
  { key: "lasers", label: "Lasers", priceExcl: 74.38, priceIncl: 90.0 },
  {
    key: "lastoestellen",
    label: "Lastoestellen",
    priceExcl: 61.98,
    priceIncl: 75.0,
  },
  {
    key: "magneetboormachines",
    label: "Magneetboormachines",
    priceExcl: 74.38,
    priceIncl: 90.0,
  },
  { key: "makita", label: "Makita", priceExcl: 45.45, priceIncl: 55.0 },
  { key: "metabo", label: "Metabo", priceExcl: 45.45, priceIncl: 55.0 },
  {
    key: "ontspanners",
    label: "Ontspanners",
    priceExcl: 45.45,
    priceIncl: 55.0,
  },
  {
    key: "plasmatoestellen",
    label: "Plasmatoestellen",
    priceExcl: 61.98,
    priceIncl: 75.0,
  },
  {
    key: "remko_klein",
    label: "Remko klein",
    priceExcl: 74.38,
    priceIncl: 90.0,
  },
  {
    key: "remko_groot",
    label: "Remko groot",
    priceExcl: 157.02,
    priceIncl: 190.0,
  },
  { key: "ridgid", label: "Ridgid", priceExcl: 111.57, priceIncl: 135.0 },
  { key: "rodcraft", label: "Rodcraft", priceExcl: 74.38, priceIncl: 90.0 },
  {
    key: "snijbranders",
    label: "Snijbranders",
    priceExcl: 45.45,
    priceIncl: 55.0,
  },
  { key: "toortsen", label: "Toortsen", priceExcl: 45.45, priceIncl: 55.0 },
];

const BESTEK_FORFAIT_EFFECTIVE_FROM = "2023-01-05";

const findBestekForfaitByKey = (key) =>
  BESTEK_FORFAIT_DIAGNOSTIEK.find((item) => item.key === key) || null;

const findBestekForfaitByPriceExcl = (priceExcl) => {
  const n = Number(priceExcl);
  if (!Number.isFinite(n)) return null;
  return (
    BESTEK_FORFAIT_DIAGNOSTIEK.find(
      (item) => Math.abs(item.priceExcl - n) < 0.005
    ) || null
  );
};

module.exports = {
  BESTEK_FORFAIT_DIAGNOSTIEK,
  BESTEK_FORFAIT_EFFECTIVE_FROM,
  findBestekForfaitByKey,
  findBestekForfaitByPriceExcl,
};
